var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (ngRequired, required) {pug_mixins["centered-content"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "centered-content","layout": "row"},attributes]), true)) + "\u003E\u003Cdiv class=\"content\" layout=\"column\" layout-align=\"start stretch\" flex flex-md=\"90\" flex-lg=\"80\" flex-gt-lg=\"70\" flex-offset-md=\"5\" flex-offset-lg=\"10\" flex-offset-gt-lg=\"15\"\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["contentful-component"] = pug_interp = function(component){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-if", "" + component + ".fields.type === 'wide'", true, true)) + "\u003E\u003Cicon-panel" + (" class=\"wide-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E\u003C\u002Fdiv\u003E";
pug_mixins["centered-content"].call({
block: function(){
pug_html = pug_html + "\u003Cicon-panel" + (" class=\"standard-panel\""+pug.attr("panel", "" + component, true, true)) + "\u003E\u003C\u002Ficon-panel\u003E";
},
attributes: {"ng-if": pug.escape("" + component + ".fields.type !== 'wide'")}
});
};





























pug_mixins["required-radio-container"] = pug_interp = function(name, model, layout){
var block = (this && this.block), attributes = (this && this.attributes) || {};
ngRequired = attributes['ng-required']
required = !ngRequired
layout = layout || 'row'
pug_html = pug_html + "\u003Cmd-radio-group" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("ng-model", model, true, true)+pug.attr("layout", layout, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003Chelp-mate" + (pug.attr("topic", name, true, true)) + "\u003E\u003C\u002Fhelp-mate\u003E\u003C\u002Fmd-radio-group\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("ng-required", ngRequired, true, true)+pug.attr("required", required, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E";
};








pug_mixins["required-select"] = pug_interp = function(name, model, label){
var block = (this && this.block), attributes = (this && this.attributes) || {};
label = label || name
pug_html = pug_html + "\u003Cinput-container" + (pug.attr("label", label, true, true)) + "\u003E\u003Cmd-select" + (" class=\"required-select big-list\""+pug.attr("ng-model", model, true, true)+pug.attr("ng-class", "'" + name + "'", true, true)+pug.attr("placeholder", label, true, true)+pug.attr("aria-label", label, true, true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fmd-select\u003E\u003Cinput-container class=\"hidden-input\"\u003E\u003Cinput" + (pug.attr("required", true, true, true)+pug.attr("name", name, true, true)+pug.attr("ng-model", model, true, true)+" ng-show=\"false\" aria-label=\"require\"") + "\u003E\u003C\u002Finput-container\u003E\u003C\u002Finput-container\u003E";
};










































































pug_mixins["rateDisplay"] = pug_interp = function(rate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + (pug.escape(null == (pug_interp = rate) ? "" : pug_interp)) + "\u003Cimg src=\"\u002Ficons\u002Ficon-percent-pa.svg\" alt=\"percentage pa\"\u003E";
};












pug_html = pug_html + "\u003Cmd-progress-linear ng-if=\"vm.loading\" md-mode=\"indeterminate\"\u003E\u003C\u002Fmd-progress-linear\u003E\u003Cdiv class=\"md-padding\" ng-if=\"!vm.loading &amp;&amp; !vm.isFinancial\"\u003E\u003Ch2\u003ELoan history (FUNDED INVESTORS ONLY)\u003C\u002Fh2\u003E\u003Chelp-box\u003E\u003Cp\u003ETo see information about the borrower's loan history, please log in to your account.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"md-padding\" ng-if=\"!vm.loading &amp;&amp; vm.isFinancial\"\u003E\u003Chelp-box heading=\"Loan history\"\u003E\u003Cp\u003EBelow is the borrower's loan history. If repayments were made late or are overdue, or if there have been any other adverse events, \nthere will be additional information in the \u003Ci\u003EComments\u003C\u002Fi\u003E column.\n\u003C\u002Fp\u003E\u003C\u002Fhelp-box\u003E\u003Chelp-box class=\"warning\" ng-if=\"vm.loanRequest.loanSummary.loanComment\"\u003E\u003Cdiv layout=\"row\"\u003E\u003Cdiv class=\"warning-sign\"\u003E\u003Cmd-icon class=\"warning\"\u003Ewarning\u003C\u002Fmd-icon\u003E\u003C\u002Fdiv\u003E\u003Cp ng-bind-html=\"vm.loanRequest.loanSummary.loanComment | fromMarkdown\"\u003E\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fhelp-box\u003E\u003Cdiv ng-if=\"!vm.loading &amp;&amp; vm.isFinancial &amp;&amp; !vm.overdue\" layout=\"row\" layout-align=\"center center\"\u003E\u003Cmd-button class=\"md-raised ios-rendering-fix md-accent listings-button\" if-media-size=\"xs\" ui-sref=\"loanRequestDetails.listings\" aria-label=\"See listings\"\u003ESee listings\u003C\u002Fmd-button\u003E\u003C\u002Fdiv\u003E\u003Cmd-table-container\u003E\u003Ctable md-table md-progress=\"vm.loadingPromises\"\u003E\u003Cthead md-head\u003E\u003Ctr md-row\u003E\u003Cth class=\"due-date\" md-column\u003EDue date\u003C\u002Fth\u003E\u003Cth class=\"repayment-date\" md-column\u003ERepayment date\u003C\u002Fth\u003E\u003Cth class=\"principal\" md-column md-numeric if-media-size=\"gt-xs\"\u003EPrincipal\u003C\u002Fth\u003E\u003Cth class=\"interest\" md-column md-numeric if-media-size=\"gt-xs\"\u003EInterest\u003C\u002Fth\u003E\u003Cth class=\"total\" md-column md-numeric\u003ETotal amount\u003C\u002Fth\u003E\u003Cth class=\"balance\" md-column md-numeric if-media-size=\"gt-md\"\u003EBalance\u003C\u002Fth\u003E\u003Cth class=\"status\" md-column\u003EStatus\u003C\u002Fth\u003E\u003C\u002Ftr\u003E\u003C\u002Fthead\u003E\u003Ctbody md-body ng-repeat=\"entry in vm.entries\"\u003E\u003Ctr md-row ng-class=\"entry.statusClass\"\u003E\u003Ctd class=\"due-date\" md-cell\u003E{{ entry.dueDate | date: 'd MMM yyyy' }}\u003C\u002Ftd\u003E\u003Ctd class=\"repayment-date\" md-cell\u003E{{ entry.repaymentDate | date: 'd MMM yyyy' }}{{ entry.repaymentDate && entry.type === 'scheduled' ? '*' : '' }}\u003C\u002Ftd\u003E\u003Ctd class=\"principal\" md-cell if-media-size=\"gt-xs\"\u003E {{ entry.principal | asCurrency }}\u003C\u002Ftd\u003E\u003Ctd class=\"interest\" md-cell if-media-size=\"gt-xs\"\u003E {{ entry.interest | asCurrency }}\u003C\u002Ftd\u003E\u003Ctd class=\"total\" md-cell\u003E {{ entry.total | asCurrency }}\u003C\u002Ftd\u003E\u003Ctd class=\"balance\" md-cell if-media-size=\"gt-md\"\u003E {{ entry.balance | asCurrency }}\u003C\u002Ftd\u003E\u003Ctd class=\"status\" md-cell\u003E{{ entry.status }}\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003Ctr class=\"comment\" md-row ng-if=\"entry.comment\"\u003E\u003Ctd class=\"comment\" md-cell colspan=\"7\"\u003E\u003Cdiv class=\"comment-content\" ng-bind-html=\"entry.comment | fromMarkdown\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Ftd\u003E\u003C\u002Ftr\u003E\u003C\u002Ftbody\u003E\u003C\u002Ftable\u003E\u003Cdiv class=\"disclaimer\" ng-if=\"vm.entries.length &gt; 0 &amp;&amp; vm.loanSummary.nextRepaymentSummary.expectedDate &amp;&amp; !vm.repaymentOverdue\"\u003E* Expected distribution date after funds clear\u003C\u002Fdiv\u003E\u003C\u002Fmd-table-container\u003E\u003C\u002Fdiv\u003E";}.call(this,"ngRequired" in locals_for_with?locals_for_with.ngRequired:typeof ngRequired!=="undefined"?ngRequired:undefined,"required" in locals_for_with?locals_for_with.required:typeof required!=="undefined"?required:undefined));;return pug_html;};
module.exports = template;